class CacheEntry {
  constructor({ response, expiration, tags }: { response: Response; expiration: Date; tags: string[] }) {
    this.response = response
    this.expiration = expiration
    this.tags = tags
  }
  response: Response
  expiration: Date
  tags: string[]

  expired() {
    return this.expiration < new Date()
  }
}

export class ResponseCache {
  private static readonly MINUTES = 1000 * 60
  private readonly data: Map<string, CacheEntry> = new Map()
  private readonly duration

  constructor(duration?: number) {
    this.duration = duration ?? ResponseCache.MINUTES * 2;
  }

  public getValue(key: string) {
    const entry = this.data.get(key)

    if (!entry)
      return

    if (entry.expired()) {
      this.data.delete(key)
      return
    }

    return entry.response
  }

  public addValue(key: string, response: Response, tags: string[], duration?: number) {
    const entry = new CacheEntry({
      response: response,
      expiration: new Date(new Date().getTime() + (duration ?? this.duration)),
      tags,
    })

    this.data.set(key, entry)

    return entry.response
  }

  public invalidate(tags: string[]) {
    for (const [key, entry] of this.data) {
      if (entry.tags.some(t => tags.includes(t))) {
        this.data.delete(key)
      }
    }
  }

  public clear() {
    this.data.clear()
  }
}
